import { render, staticRenderFns } from "./sightseeing.vue?vue&type=template&id=609d12ce&scoped=true"
import script from "./sightseeing.vue?vue&type=script&lang=js"
export * from "./sightseeing.vue?vue&type=script&lang=js"
import style0 from "./sightseeing.vue?vue&type=style&index=0&id=609d12ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d12ce",
  null
  
)

export default component.exports